<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { addSubPackage } from "../../../api/services/sub-package.service";
import { getAddOns } from "../../../api/services/addon.service";
import { getPackages } from "../../../api/services/package.service";
import { newSubpackageObject } from "./subpackage-controller";
import { getS3SingedUrl } from "../../../api/services/general.service";
import SubpackageImageCroperModel from "../../../components/models/subpackage-image-crop";

export default {
	props: {
		visible: Boolean,
		closeable: Boolean,
	},
	components: {
		Multiselect,
		"subpackage-image-cropper-model": SubpackageImageCroperModel,
	},
	data() {
		return {
			subpackageTitle: null,
			subpackageDescription: null,
			subpackageTitleImageURL: null,
			subpackagePrice: null,
			subpackageTimeDuration: null,
			subpackageTripLength: null,
			selectedPackageForSubpackage: null,
			selectedExtrasForSubpackage: null,
			packagesToSelect: [],
			extrasToSelect: [],
			isUploadingProcessing: false,
			isUploadSuccess: false,
			isUploadFailed: false,
			isFormSubmited: false,
			croppedSubpackageImage: null,
			subpackageImageFileToCrop: null,
			showSubpackageImageCropModel: false,
			subpackagePriority: null,
		};
	},
	validations: {
		subpackageTitle: { required },
		subpackageDescription: { required },
		subpackageTimeDuration: { required },
		subpackagePrice: { required },
		subpackagePriority: { required },
	},
	computed: {
		showModal: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit("close");
				}
			},
		},
	},
	async mounted() {
		await this.getAllExtras();
		await this.getAllPackages();
	},
	methods: {
		async clickCreateSubpackageButton() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isFormSubmited = true;
				this.isUploadingProcessing = true;

				let newSubpackageObject_Pass = new newSubpackageObject();
				newSubpackageObject_Pass.subpackageTitle = this.subpackageTitle;
				newSubpackageObject_Pass.subpackageDescription = this.subpackageDescription;
				newSubpackageObject_Pass.subpackageTitleImageURL = this.subpackageTitleImageURL;
				newSubpackageObject_Pass.subpackageTimeDuration = Number(
					this.subpackageTimeDuration
				);
				newSubpackageObject_Pass.subpackageTripLength = Number(
					this.subpackageTripLength
				);
				newSubpackageObject_Pass.subpackagePrice = Number(this.subpackagePrice);
				newSubpackageObject_Pass.subpackagePriority = Number(
					this.subpackagePriority
				);

				if (this.selectedExtrasForSubpackage) {
					for (let i = 0; i < this.selectedExtrasForSubpackage.length; i++) {
						newSubpackageObject_Pass.selectedExtrasForSubpackage.push(
							this.selectedExtrasForSubpackage[i].id
						);
					}
				}

				newSubpackageObject_Pass.selectedPackageForSubpackage = this.selectedPackageForSubpackage.id;

				if (this.croppedSubpackageImage) {
					const subpackageImageFile = this.$refs.subpackageImageInput.files[0];
					const croppedSubpackageImage = this.croppedSubpackageImage;
					const finalSubpackageImageToPass = await new Promise(function(
						resolve
					) {
						return croppedSubpackageImage.toBlob(
							resolve,
							subpackageImageFile.type
						);
					});
					const fileName = subpackageImageFile.name;
					let getUploadedImageURL = await getS3SingedUrl(fileName);

					let getFileUploadResponse = await axios.put(
						getUploadedImageURL.signedUrl,
						finalSubpackageImageToPass
					);

					if (getFileUploadResponse) {
						let fileBaseUrl =
							"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
						newSubpackageObject_Pass.subpackageTitleImageURL =
							fileBaseUrl + fileName;
					}
				}

				let subpackageCreationSuccess = await addSubPackage(
					newSubpackageObject_Pass
				);

				if (subpackageCreationSuccess) {
					this.isUploadingProcessing = false;
					this.isUploadSuccess = true;
				} else if (!subpackageCreationSuccess) {
					this.isUploadingProcessing = false;
					this.isUploadFailed = true;
				}
			} else {
				console.log("Validation Error"); //eslint-disable-line
			}
		},
		async getAllPackages() {
			let getAllPackages = await getPackages();
			if (getAllPackages.length > 0) {
				this.packagesToSelect = [...getAllPackages];
			}
		},
		async getAllExtras() {
			let getAllExtras = await getAddOns();
			if (getAllExtras.length > 0) {
				this.extrasToSelect = [...getAllExtras];
			}
		},
		subpackageImageSelected() {
			const imagePreviewCanvers = this.$refs.subpackageImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const subpackageImageFile = this.$refs.subpackageImageInput.files[0];
			this.openCorpSubpackageImageModel(subpackageImageFile);
		},
		setCroppedImageToPreview(croppedImage) {
			const imagePreview = this.$refs.subpackageImagePreview;
			const imagePreviewCanvers = this.$refs.subpackageImageCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 450, 200);
			}
			this.croppedSubpackageImage = croppedImage;
			this.showSubpackageImageCropModel = false;
		},
		openCorpSubpackageImageModel(subpackageImageFile) {
			this.subpackageImageFileToCrop = subpackageImageFile;
			this.showSubpackageImageCropModel = true;
		},
		clickRemoveSubpackageImage() {
			this.croppedSubpackageImage = null;
			const imagePreviewCanvers = this.$refs.subpackageImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);
		},
		clickCloseButton() {
			this.$emit("reload");
		},
	},
};
</script>

<template>
	<!-- Edit Company Model-->
	<b-modal
		v-model="showModal"
		:title="this.$i18n.t('subpackages.createSubpackage.title')"
		centered
		hide-footer
		no-close-on-backdrop
		no-close-on-esc
		scrollable
	>
		<div class="row" v-if="!isFormSubmited">
			<!--- Subpackage Image -->
			<div class="col-md-12 mb-5">
				<div class="avatar-md mr-4">
					<span
						ref="subpackageImagePreview"
						class="subpackage-image-preview-after-crop"
					>
						<canvas
							id="subpackageImageCanvas"
							ref="subpackageImageCanvas"
							height="200"
							width="450"
						></canvas>
						<span
							v-if="!this.croppedSubpackageImage"
							class="avatar-title bg-white"
							style="margin-left: -450px"
						>
							<img
								src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/images/ms-sissi-Default-Subpackage.jpg"
								class="rounded-0"
								alt
								height="200"
							/>
						</span>
					</span>
				</div>
			</div>
			<div class="col-md-12 mt-5 mb-4">
				<div class="mt-3">
					<input
						id="subpackageImageInput"
						ref="subpackageImageInput"
						type="file"
						name="file"
						accept="image/*"
						@change="subpackageImageSelected()"
						style="width: 0.1px; opacity: 0; z-index: -1"
					/>
					<div>
						<label
							for="subpackageImageInput"
							class="text-info"
							style="cursor: pointer"
						>
							{{ $t("extras.createExtra.form.uploadNewImage") }}
						</label>
						<label class="ml-2" v-if="this.croppedSubpackageImage">
							&#8226;
						</label>
						<label
							class="text-info ml-2"
							@click="clickRemoveSubpackageImage()"
							style="cursor: pointer"
							v-if="this.croppedSubpackageImage"
						>
							{{ $t("extras.createExtra.form.removeImage") }}
						</label>
					</div>
					<div class="text-mute">
						<small>
							{{ $t("extras.createExtra.form.imageSupportText") }}
							<br />
							<b> Bildgröße 1410px * 915px </b>
						</small>
					</div>
				</div>
			</div>
			<!-- Subpackage Title -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.titleLabel") }}
						<span class="text-danger">*</span>
						<span class="ml-2">
							<p
								v-if="subpackageTitle"
								class="badge position-absolute"
								:class="{
									'badge-light': subpackageTitle.length !== 60,
									'badge-danger': subpackageTitle.length === 60,
								}"
							>
								{{ subpackageTitle.length }} / 60
							</p>
						</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="subpackageTitle"
							:placeholder="
								this.$i18n.t(
									'subpackages.createSubpackage.form.titlePlaceholder'
								)
							"
							:maxlength="60"
							:class="{ 'is-invalid': $v.subpackageTitle.$error }"
						></b-form-input>
						<div v-if="$v.subpackageTitle.$error" class="invalid-feedback">
							<span
								v-if="$v.subpackageTitle.$error && !$v.subpackageTitle.required"
								>{{
									$t("subpackages.createSubpackage.form.titleRequiredMsg")
								}}</span
							>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- Subpackage Descrtiption -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.descriptionLabel") }}
						<span class="text-danger">*</span>
						<span class="ml-2">
							<p
								v-if="subpackageDescription"
								class="badge position-absolute"
								:class="{
									'badge-light': subpackageDescription.length !== 275,
									'badge-danger': subpackageDescription.length === 275,
								}"
							>
								{{ subpackageDescription.length }} / 275
							</p>
						</span>
					</label>
					<textarea
						v-model="subpackageDescription"
						class="form-control"
						name="textarea"
						rows="5"
						:maxlength="275"
						:placeholder="
							this.$i18n.t(
								'subpackages.createSubpackage.form.descriptionPlaceholder'
							)
						"
						:class="{ 'is-invalid': $v.subpackageDescription.$error }"
					></textarea>
					<div v-if="$v.subpackageDescription.$error" class="invalid-feedback">
						<span
							v-if="
								$v.subpackageDescription.$error &&
									!$v.subpackageDescription.required
							"
							>{{
								$t("subpackages.createSubpackage.form.descriptionRequiredMsg")
							}}</span
						>
					</div>
				</div>
			</div>
			<!-- Subpackage Time Duration -->
			<div class="col-md-6">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.timeDurationLabel") }}
						<span class="text-danger">*</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="subpackageTimeDuration"
							type="number"
							:placeholder="
								this.$i18n.t(
									'subpackages.createSubpackage.form.timeDeurationPlaceholder'
								)
							"
							:class="{ 'is-invalid': $v.subpackageTimeDuration.$error }"
						></b-form-input>
						<div
							v-if="$v.subpackageTimeDuration.$error"
							class="invalid-feedback"
						>
							<span
								v-if="
									$v.subpackageTimeDuration.$error &&
										!$v.subpackageTimeDuration.required
								"
								>{{
									$t(
										"subpackages.createSubpackage.form.timeDeurationRequiredMsg"
									)
								}}</span
							>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- Subpackage Length -->
			<div class="col-md-6">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.lengthLeable") }}
					</label>
					<b-form-group>
						<b-form-input
							v-model="subpackageTripLength"
							type="number"
							:placeholder="
								this.$i18n.t(
									'subpackages.createSubpackage.form.lengthPlaceholder'
								)
							"
						></b-form-input>
					</b-form-group>
				</div>
			</div>
			<!-- Select Extras -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.selectExtrasLabel") }}
					</label>
					<multiselect
						track-by="title"
						label="title"
						v-model="selectedExtrasForSubpackage"
						:options="extrasToSelect"
						:multiple="true"
						:placeholder="
							this.$i18n.t(
								'subpackages.createSubpackage.form.selectExtrasPlcaholder'
							)
						"
					>
						<template slot="singleLabel" slot-scope="{ option }">
							{{ option.title }}</template
						></multiselect
					>
				</div>
			</div>
			<!-- Select Package -->
			<div class="col-md-6">
				<div class="mb-4">
					<label
						>{{ $t("subpackages.createSubpackage.form.selectPackageLabel") }}
						<span class="text-danger">*</span>
					</label>
					<multiselect
						track-by="title"
						label="title"
						v-model="selectedPackageForSubpackage"
						:options="packagesToSelect"
						:placeholder="
							this.$i18n.t(
								'subpackages.createSubpackage.form.selectPackagePlaceholder'
							)
						"
						><template slot="singleLabel" slot-scope="{ option }">
							{{ option.title }}</template
						></multiselect
					>
				</div>
			</div>
			<!-- Subpackage Price -->
			<div class="col-md-6">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.priceLabel") }}
						<span class="text-danger">*</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="subpackagePrice"
							:placeholder="
								this.$i18n.t(
									'subpackages.createSubpackage.form.pricePlaceholder'
								)
							"
							:class="{ 'is-invalid': $v.subpackagePrice.$error }"
							type="number"
						></b-form-input>
						<div v-if="$v.subpackagePrice.$error" class="invalid-feedback">
							<span
								v-if="$v.subpackagePrice.$error && !$v.subpackagePrice.required"
								>{{
									$t("subpackages.createSubpackage.form.priceRequiredMsg")
								}}</span
							>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- SubPackage Priority -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("subpackages.createSubpackage.form.priorityLabel") }}
						<span class="text-danger">*</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="subpackagePriority"
							:placeholder="
								this.$i18n.t(
									'subpackages.createSubpackage.form.priorityPlaceholder'
								)
							"
							:class="{ 'is-invalid': $v.subpackagePriority.$error }"
							type="number"
						></b-form-input>
						<div v-if="$v.subpackagePriority.$error" class="invalid-feedback">
							<span
								v-if="
									$v.subpackagePriority.$error &&
										!$v.subpackagePriority.required
								"
								>{{
									$t("subpackages.createSubpackage.form.priorityRequiredMsg")
								}}</span
							>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- Save Button -->
			<div class="col-md-12">
				<div class="">
					<b-button variant="success" @click="clickCreateSubpackageButton()">
						<i class="bx bxs-check-circle mr-1"></i>
						{{ $t("general.buttons.create") }}</b-button
					>
				</div>
			</div>
		</div>
		<div class="row" v-else>
			<!-- Uploading Processing -->
			<div class="col-md-12 text-center" v-if="isUploadingProcessing">
				<b-spinner
					style="width: 5rem; height: 5rem"
					class="m-2"
					variant="warning"
					role="status"
				></b-spinner>
				<h5 class="mt-3">
					{{ $t("subpackages.createSubpackage.form.uploadProcessingTitle") }}
				</h5>
				<p class="mt-3">
					{{ $t("subpackages.createSubpackage.form.uploadProcessingText") }}
				</p>
			</div>
			<!-- Upload Success -->
			<div class="col-md-12 text-center" v-if="isUploadSuccess">
				<i class="bx bx-check-circle bx-tada text-success display-1"></i>
				<h5 class="mt-3">
					{{ $t("subpackages.createSubpackage.form.uploadSuccesTitle") }}
				</h5>
				<p class="mt-3 mb-3">
					{{ $t("subpackages.createSubpackage.form.uploadSuccessText") }}
				</p>
				<b-button variant="warning" @click="clickCloseButton()">
					<i class="bx bxs-x-circle mr-1"></i>
					{{ $t("general.buttons.close") }}</b-button
				>
			</div>
			<!-- Upload Failed -->
			<div class="col-md-12 text-center" v-if="isUploadFailed">
				<i class="bx bx-x-circle bx-tada text-danger display-1"></i>
				<div class="mt-3">
					{{ $t("subpackages.createSubpackage.form.uploadFailedTitle") }}
				</div>
				<p class="mt-3">
					{{ $t("subpackages.createSubpackage.form.uploadFailedText") }}
				</p>
			</div>
		</div>

		<!-- Image Cropper Model -->
		<subpackage-image-cropper-model
			v-if="this.showSubpackageImageCropModel === true"
			:visible="showSubpackageImageCropModel"
			@close="showSubpackageImageCropModel = false"
			:imageFile="subpackageImageFileToCrop"
			@apply="setCroppedImageToPreview"
		/>
	</b-modal>
</template>

<style scoped>
.subpackage-image-preview-after-crop {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: none;
	width: 450px;
	height: 200px;
	padding: 0;
	margin: 0;
}
</style>
